<template>
  <section>
      <div class="d-flex justify-content-start align-items-end mb-2">  
        <b-form-group class="mr-4">
          <b-form-checkbox-group
            v-model="showing"
            :options="options"
            switches
          ></b-form-checkbox-group>
        </b-form-group>
      
        <b-form-group class="mr-3">
          <b-form-checkbox v-model="isShowAvl" switch button-variant="success">
            Show AVL
          </b-form-checkbox>     
        </b-form-group>
        <b-form-group>
          <b-form-checkbox v-model="isShowNonAvl" switch button-variant="success">
            Show Non-AVL
          </b-form-checkbox>     
        </b-form-group>  
        
        <b-form-group label="Sort By" class="ml-4">
          <b-form-select v-model="sortBy">
            <option v-for="(select, index) in sortOptions" :key="index" :value="select.value">{{ select.text }}
            </option>
          </b-form-select>
        </b-form-group> 

        <b-form-group label="Sort Order" class="ml-1">
          <b-form-select v-model="sortOrder">
          <option v-for="(select, index) in ['ascending', 'descending']" :key="index">{{ select }}
          </option>
        </b-form-select>  
        </b-form-group>
        

      </div>  
      <h6 class="mb-3">(Note: Only the displayed vendors and selected part will be sent for email)</h6>
      <div v-if="itemData.length > 0" class="sourcing-scrollable">
        
        <div v-for="(item, i) in itemData" :key="i">
          <!-- <b-table :fields="vendorFields" fixed no-border-collapse  :items="[item]" style="margin-bottom: 0rem !important "></b-table> -->
          <b-row>
            <b-col cols="3">
              <b-form-checkbox :checked="item.selected" :indeterminate="item.indeterminate" @input.native="onCheckedVendor(item,$event)">
                <strong class="mr-1"> <i class="mr-1" style="color: red" :class="isAscendingOrder ? 'fa fa-caret-up' : 'fa fa-caret-down'" v-if="sortBy == 'vendorName'"></i>Vendor: </strong> 
                <a @click="onNavigateVendor(item.vendorId)" :class="item.isAVL ? 'text-green-link' : 'text-blue-link'">
                  {{ item.vendorName }} <b-badge v-if="item.isAVL" class="ml-1" variant="success">AVL</b-badge>
                </a>                 
              </b-form-checkbox>
            </b-col>
            <b-col cols="1"><span><strong><i class="mr-1" style="color: red" :class="isAscendingOrder ? 'fa fa-caret-up' : 'fa fa-caret-down'" v-if="sortBy == 'rating'"></i>Rating: </strong> {{ item.rating > 0 ? item.rating +'/5' : 'N/R' }}</span></b-col>
            <b-col cols="1"><span><strong><i class="mr-1" style="color: red" :class="isAscendingOrder ? 'fa fa-caret-up' : 'fa fa-caret-down'" v-if="sortBy == 'vendorType'"></i>Type: </strong> {{ item.vendorType || '-' }}</span></b-col>
            <b-col cols="2"><span><strong>Contact: </strong> 
              <a @click="onNavigateContact(item.vendorId, item.contactId)" :class="item.isAVL ? 'text-green-link' : 'text-blue-link'">
                {{ item.contactName }}
              </a></span>
            </b-col>
            <b-col cols="2"><span><strong>Phone: </strong> {{ item.phone }}</span></b-col>
            <b-col cols="2"><span><strong>Email: </strong> {{ item.email }}</span></b-col>
            <b-col cols="1"><span><strong>Added: </strong> {{ date(item.dateAdded) || '-' }}</span></b-col>
          </b-row>
          <b-table :fields="partFields" responsive hover small ref="partTable" :head-variant="'light'" :items="item.children" @row-selected="onRowSelected">
            <template #table-colgroup="scope">
              <col
                v-for="field in scope.fields"
                :key="field.key"
                :style="{ width: field.key === 'select' ? '20px' : '180px' }"
              >
            </template>
            <template #cell(select)="{ item }">
                <b-form-checkbox :checked="item.selected" @input="onRowSelected(item, $event)" />  
            </template> 
            <template #cell(dateOffered)="{ item }">
              <a @click="onOfferClick({ partId: item.partId, vendorId: item.vendorId, offerId: item.offerId })" :class="item.isAVL ? 'text-green-link' : 'text-blue-link'">
                {{  date(item.dateOffered) || '-' }}
              </a>
            </template>      
            <template #cell(dateSent)="data">
              {{  date(data.value) || '-' }}
            </template>      
          </b-table>
          <hr/>
        </div>
      </div>
      <div v-else>
        <center><h6>No sourcing data  </h6></center>
      </div>
      <offer-form :modalId="'offer-vendor-modal'" :partId="partIdOnForm" :offerId="offerIdOnForm" :companyId="companyIdOnForm" />
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import GridSettings from '@/shared/components/GridSettings';
import GridComponent from '@/shared/components/GridComponent';
import  reportApi  from '@/resources/reportApi'
import 'vue-good-table/dist/vue-good-table.css';
import {VueGoodTable} from 'vue-good-table';
import { date } from '@/shared/filters';
import OfferForm from '@/shared/components/Offers/components/AddOffer';

import debounce from 'lodash/debounce';
import isEqual from 'lodash.isequal';

import { GRID_ID, DATE_FORMAT } from '@/shared/constants';
import { prepareColumnsData } from '@/shared/helpers';
import moment from 'moment';

import { vendorFields, partFields } from './fields';

const MIN_DATE_SENT = '0001-01-01T00:00:00';

export default {
  components: {
    GridSettings,
    GridComponent,
    VueGoodTable,
    OfferForm
  },
  data: () => ({
    date,
    DATE_FORMAT,
    prepareColumnsData,
    vendorFields,
    partFields,
    checkedRowItemIds: [],
    gridId: GRID_ID.RFP_DETAILS_SELECTED_VENDORS,
    showing: ['offer-sourced', 'mfr-sourced', 'manually-selected'],
    options: [
      {text: 'Offer Sourcing', value:'offer-sourced'},
      {text: 'Mfr Sourcing', value:'mfr-sourced'},
      {text: 'Manual Sourcing', value: 'manually-selected'}
    ],
    isRunning: false,
    selectedRows: [],
    checkedVendors: [],
    selected: [],
    partIdOnForm: 0,
    lineIdOnForm: 0,
    offerIdOnForm: 0,
    companyIdOnForm: 0,
    isShowAvl: true,
    isShowNonAvl: false,
    sortBy: 'vendorName',
    sortOptions: [
      {text: 'Vendor Name', value:'vendorName'},
      {text: 'Date Added', value:'dateAdded'},
      {text: 'Rating', value: 'rating'},
      {text: 'Type', value: 'vendorType'}
    ],
    sortOrder: 'ascending'
  }),
  props: {
    rfpHome: {
      default: false,
      type: Boolean,
    }
  },
  computed: {
    ...mapGetters('account', ['gridSettingsById']),
    ...mapGetters('rfpSelectedVendors', ['selectedVendors']),
    ...mapGetters('rfps', ['selectedRfpId']),
    gridSettings() {
      return this.gridSettingsById(GRID_ID.RFP_DETAILS_SELECTED_VENDORS);
    },
    itemData() {
      // return this.selectedVendors;
      let offer = this.showing.findIndex(x => x == 'offer-sourced') > -1;
      let mfr = this.showing.findIndex(x => x == 'mfr-sourced') > -1;
      let manual = this.showing.findIndex(x => x == 'manually-selected') > -1;
      let data = [], avls = [], nonavls = [];

      if ((!manual && !mfr && !offer)) {
        if (this.isShowAvl || this.isShowNonAvl) 
          data = this.selectedVendors.filter(x => x.active == 1);
        else if (!this.isShowAvl && !this.isShowNonAvl)
          data = [];
      } else if (manual && mfr && offer) {
        data = this.selectedVendors.filter(x => x.active == 1);
      } else {
        for (let i = 0; i < this.selectedVendors.filter(x => x.active == 1).length; i++) {
          let parts = [];

          for (let j = 0; j < this.selectedVendors[i].children.length; j++) {
            let isAdded = false;

            if (offer && this.selectedVendors[i].children[j].isOfferSourced && !isAdded) {
              parts.push(this.selectedVendors[i].children[j]);
              isAdded = true;
            } 
            if (mfr && this.selectedVendors[i].children[j].isMfrSourced && !isAdded) {
              parts.push(this.selectedVendors[i].children[j]);
              isAdded = true;
            }
            if (manual && this.selectedVendors[i].children[j].isManualSourced && !isAdded) {
              parts.push(this.selectedVendors[i].children[j]);
              isAdded = true;
            }
          }

          if (parts.length > 0) {
            data.push({ ...this.selectedVendors[i], children: parts })  
          }          
        } 
      }

      if (this.isShowAvl) avls = data.filter(x => x.isAVL);
      if (this.isShowNonAvl) nonavls = data.filter(x => !x.isAVL);

      data = avls.concat(nonavls).sort(this.sortCompare);

      return data;
    },
    rfpId() {
      if(this.rfpHome) return this.selectedRfpId;

      return this.$route.params.id;
    },
    selectedItemData() {
      let data = [];

      for (let i = 0; i < this.selectedRows.length; i++) {
        let item = this.itemData.find(x => x.vendorRFPId == this.selectedRows[i].vendorRFPId);

        if (item) {
          for (let j = 0; j < item.children.filter(x => x.selected).length; j++) {
            if (data.findIndex(x => x.id == item.id) == -1)
              data.push(item)
          }
        }
      }

      return data;
    },
    selectedForEmail() {
      return this.selectedItemData.map((item) => ({
        id: item.vendorRFPId,
        email: item.email,
        dateSent: item.dateSent
      }));
    },
    isAscendingOrder() {
      return this.sortOrder == 'ascending';
    }
  },
  methods: {
    dummyModalTmp(msg) {
      this.openAlertBox({message: msg});
    },
    ...mapActions('account', ['saveGridSettings']),
    ...mapActions('rfpSelectedVendors', ['getSelectedVendors', 'removeSelectedVendor', 'update', 'reProcessSourcing', 'updateSourcePart']),
    sortCompare(a, b) {
      if ( a[this.sortBy] < b[this.sortBy] ){
        return (this.isAscendingOrder) ? -1 : 1;
      }
      if ( a[this.sortBy] > b[this.sortBy]){
        return (this.isAscendingOrder) ? 1 : -1;
      }
      return 0;
    },
    onCheckedVendor(data, $event) {       
      if (data) {
        for (let j = 0; j < data.children.length; j++) {
          data.children[j].selected = $event.target.checked;
        }
      }      
    },
    onRowSelected(item, isChecked) {
      // console.log(item, "Item")
      item.selected = isChecked;
      let header = this.selectedVendors.find(x => x.vendorRFPId == item.vendorRFPId);
      if (header) {
        header.selected = header.children.filter(x => x.selected).length == header.children.length;
        header.indeterminate = !header.selected && header.children.filter(x => x.selected).length > 0;
      }
     
      if (isChecked) {
        let i = this.selectedRows.findIndex(x => x.id == item.id);
        if (i == -1)
          this.selectedRows.push(item);
      } 
      else {
        let i = this.selectedRows.findIndex(x => x.id == item.id);
        if (i > -1)
          this.selectedRows.splice(i, 1);
      }

      this.onSelectedRowsChange({selectedRows: this.selectedRows});
    },
    async onSelectedRowsChange({ selectedRows }) {
      if (this.rfpId) {
        const selectedRowIds = selectedRows.map(x => x.id);

        await this.updateSourcePart({rfpId: this.rfpId, selectedRowIds });

        // this.$emit('selectedVendors', selectedRows);
      }
    },
    
    isChildrenSelected(rows) {
      return rows.filter(x => x.vgtSelected == true).length > 0
    },
    getData() {
      this.isRunning = true;
      this.getSelectedVendors(this.rfpId).then(() => {
        for (let i = 0; i < this.selectedVendors.length; i++) {
          let selectedData = this.selectedVendors[i].children.filter(x => x.selected);

          for (let j = 0; j < selectedData.length; j++) {
            this.selectedRows.push(selectedData[j]);
          }
        }

        this.$emit('selectedVendors', this.selectedRows);
        this.isRunning = false;
      });
    },
    async onDelete() {
      let selectedToRemove = this.selectedItemData;

      const deleteConfirmed = await this.openConfirmBox({message: `Are you sure you want to remove selected vendors?`});
      if (deleteConfirmed) {
        let vendorRfpIds = [ ...new Set(selectedToRemove.map(x => x.vendorRFPId)) ];
        
        for (let i = 0; i < vendorRfpIds.length; i++) {
          await this.removeSelectedVendor(vendorRfpIds[i]);
        }

        if (selectedToRemove.filter(x => (x.isOfferSourced == 1 || x.isMfrSourced == 1)).length > 0) {
          this.$emit('is-suggested-deleted', true);  
        }
        
        this.getData();
      }
    },
    onOfferClick(offerValues) {
      this.partIdOnForm = offerValues.partId;
      this.offerIdOnForm = offerValues.offerId;
      this.companyIdOnForm = offerValues.vendorId;

      this.$bvModal.show('offer-vendor-modal');
    },
    onNavigateVendor(vendorId) {
      this.$router.push(`/company/${vendorId}/details`);
    },
    onNavigateContact(vendorId, contactId) {
      this.$router.push({
        name: 'company.contact.details',
        params: { id: vendorId, contactId: contactId },
      });
    }
  },
  watch: {
    async selectedRfpId() {
      if (this.rfpId != null)
        this.getData();
    }
  },
  async mounted() {
    if(!this.rfpHome) {
      this.getData();
    }
  },
};
</script>

<style lang="scss" scoped>
.grid {
  max-height: 200px;
  height: auto !important;
}

.disabled-btn {
  color: #dddddd;
  cursor: no-drop;
}

.text-blue-link {
  color: #20a8d8 !important
}

.text-green-link {
  color: #28a745 !important
}

.text-blue-link:hover, .text-green-link:hover {
  opacity: 0.7;
  cursor: pointer;
}

.avl-options .active {
  color: #fff !important;
  background-color: #28a745 !important;
  border-color: #28a745 !important;
}

.sourcing-scrollable {
  max-height: 460px !important;
  height: 259px;
  overflow-y: auto;
}

.row {
  margin-right: 0px !important;
}
</style>
